export default "__VITE_ASSET__YYry71sL__"